import { TextField } from "@mui/material";
import { useCallback } from "react";
import { ModelSavingData } from "src/hooks/use-model-saving-data";

export type TruxSelectFieldProps<T> = {
  modelSavingData: ModelSavingData<T>,
  field: keyof T,
  label?: string,
  onChange?: (t: T) => boolean | void,
  children: React.ReactNode,
  disabled?: boolean
}

export default function TruxSelectField<T>({ modelSavingData, field, onChange, children, label, disabled }: TruxSelectFieldProps<T>) {
  const fieldOnChange = useCallback((e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const val = e.target.value as any;

    const prev = modelSavingData.model?.[field] as any;
    modelSavingData.update(data => {
      data[field] = val
      modelSavingData.model![field] = val;

      if (onChange && onChange(data)) {
        data[field] = prev;
      }
    });

  }, [modelSavingData, field, onChange]);

  const currentValue = modelSavingData.model?.[field as keyof T];

  return <TextField size="small" sx={{ display: "flex", width: "100%" }} disabled={disabled} label={label} value={currentValue} onChange={fieldOnChange} select>
    {children}
  </TextField>
}